import { useSuspenseQuery } from '@tanstack/react-query';
import { TimeRangesService } from './service';

const queryKey = ['get-time-ranges'];
export const useTimeRangesQuery = (
  debugString: string,
  timeRangesService: TimeRangesService
) => {
  const key = [...queryKey, ...timeRangesService.getDeps()];
  return {
    queryKey: key,
    queryFn: async () => {
      console.debug(`[useQuery] ${debugString}`, key);
      return timeRangesService.getTimeRanges();
    },
  };
};

export const useTimeRanges = (timeRangesService: TimeRangesService) => {
  const debugString = 'useTimeRanges';
  const timeRangesQuery = useTimeRangesQuery(debugString, timeRangesService);
  return useSuspenseQuery(timeRangesQuery);
};
